import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
// const searchPrompts = async (payload) => {
//   try {
//     const response = await axios.post(`${BASE_URL}suggested-questions/`, payload, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//       },
//     });
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };



// export default searchPrompts;


const searchPrompts = (questionText) => {
  const url = `${BASE_URL}promptssuggestions/promptsearch`;

  const data = {
    question_text: questionText,
    num_of_results: 3,
    index_name: ""
  };
  const access_token = localStorage.getItem('access_token')
    if(access_token == null){
      return Promise.reject("unauthorized"); // Reject the promise with the error
    }

  return axios.post(url, data, {
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${access_token}`,
    }
  });
};


const getSuggestedQuestions = async (questionText, theme = "", userPrompt = "") => {
  // Query is sent in the body (it can get too large for a query param).
  // `search` / `question_text` query params are still supported by the API as fallback.
  const url = `${BASE_URL}pyqs/search_rag`;
  const access_token = localStorage.getItem('access_token')
  if(access_token == null){
    return Promise.reject("unauthorized"); // Reject the promise with the error
  }
  // `search` must be a single string — join keyword lists before sending.
  const search = Array.isArray(questionText)
    ? questionText.filter(Boolean).join(", ")
    : questionText;
  const data = {
    search,
  };
  if (userPrompt) {
    data.query = userPrompt;
  }
  if (theme) {
    data.theme = theme;
  }
  const response = await axios.post(url, data, {
    headers: {
      'Authorization': `Bearer ${access_token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  });
  return response.data;
}

export {getSuggestedQuestions, searchPrompts};